<template>
  <a
    class="logo-link"
    href="https://www.uptick.network/"
    target="_blank"
    rel="noopener noreferrer"
  >
    <img
      alt="Uptick Network logo"
      src="@/assets/UptickNetwork_logo.png"
      :height="height"
      :width="`${simple ? height : 'auto'}`"
      v-bind="$attrs"
      class="logo"
    />
  </a>
</template>

<script lang="js">

export default {
  name: 'Logo',
  inheritAttrs: false,

  props: {
      simple: Boolean,
      height: [String, Number]
  },
};
</script>

<style lang="scss" scoped>
.logo-link {
  display: inline-block;
  line-height: 0;
}
.logo {
  object-fit: cover;
  object-position: left;
}
</style>
